import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusLoading} from 'redux/actions'
import reduxStore from 'redux/store'
import validateSection from './helpers/validateSection';
import {DemandValidation} from 'constants/DemandValidation';

const ESPD_LIST_RESOURCE_KEY = 'espdList'

const getList = async (id, separateForEachDealing) => {

    separateForEachDealing = separateForEachDealing === undefined ? undefined : separateForEachDealing === 'true' || separateForEachDealing === true;
    const params = {
        separateForEachDealing
    }

    try {
        const espdList = await RestRequestGET(Endpoints.ESPD(id), {params});
        espdList.separateForEachDealing = String(espdList.separateForEachDealing);
        reduxStore.dispatch(setResource(ESPD_LIST_RESOURCE_KEY, espdList));
    } catch (error) {
    }
}

const _formatSingleEspd = (espd) => {

    const {
        e1, e2, e3, e4,
        s1, s2, s3, s4,
        n1,
        qualifications,
        _editable,
        ...other
    } = espd;

    let data = {
        ...e1, ...e2, ...e3, ...e4,
        ...s1, ...s2, ...s3, ...s4,
        selection: qualifications,
        declaration: qualifications === "no" ? true : false,
        ...other
    };

    return data;
}

const _save = async (url, values, force = false) => {
    const data = _formatData(values);

    try {
        await RestRequestPOST(url, data)
    } catch (error) {
    }
}

const _formatData = (values) => {
    const {espd, separateForEachDealing, espds} = values;
    const separate = separateForEachDealing === 'true' || separateForEachDealing === true;
    const data = {separateForEachDealing: separate, espds: null, espd: null};

    if (separate) {
        data.espds = [];
        for (let i = 0; i < espds.length; i++)
            data.espds.push(_formatSingleEspd(espds[i]));
    } else {
        data.espd = _formatSingleEspd(espd);
    }
    return data;
}

const save = async (id, values) => {
    reduxStore.dispatch(setSaveStatusLoading())
    try {
        const res = await _save(Endpoints.ESPD_SAVE(id), values, true)
        reduxStore.dispatch(setSaveStatusDialog())
        if (res !== null) {
            await validateSection(DemandValidation.ESPD, id);
        }
    } catch (error) {
        console.error(error)
    }
}

const validate = async (id) => {
    return RestRequestGET(Endpoints.ESPD_VALIDATE(id));
}

const checkForDraft = async (id) => {
    return await RestRequestGET(Endpoints.ESPD_AUTOSAVE_CHECK(id));
}

const loadDraft = async (id) => {
    const res = await RestRequestGET(Endpoints.ESPD_AUTOSAVE(id));
    res.result.separateForEachDealing = String(res.result.separateForEachDealing);
    reduxStore.dispatch(setResource(ESPD_LIST_RESOURCE_KEY, res.result));
    return res;
}

const saveDraft = async (id, formValues) => {
    const data = _formatData(formValues);
    await RestRequestPOST(Endpoints.ESPD_AUTOSAVE(id), data);
}

const deleteDraft = async (id) => {
    await RestRequestDELETE(Endpoints.ESPD_AUTOSAVE(id));
}

export const clearEspdList = () => {
    reduxStore.dispatch(clearResource(ESPD_LIST_RESOURCE_KEY));
}

const exportPDF = async (demandId, dealingId) => {
    if (dealingId) {
        return RestRequestBLOB(Endpoints.ESPD_PRINT_FOR_DEALING(demandId, dealingId));
    } else {
        return RestRequestBLOB(Endpoints.ESPD_PRINT_FOR_DEMAND(demandId));
    }
}
const exportXML = async (demandId, dealingId) => {
    if (dealingId) {
        return RestRequestBLOB(Endpoints.ESPD_EXPORT_FOR_DEALING(demandId, dealingId));
    } else {
        return RestRequestBLOB(Endpoints.ESPD_EXPORT_FOR_DEMAND(demandId));
    }
}

export default {
    save,
    validate,
    getList,
    checkForDraft,
    loadDraft,
    saveDraft,
    deleteDraft,
    clearEspdList,
    exportPDF,
    exportXML,
    ESPD_LIST_RESOURCE_KEY
}